import { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("hp-cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("hp-cart", JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((item, openDrawer = true) => {
    setItems((prev) => {
      const key = item.key || item.id;
      const existing = prev.find((i) => (i.key || i.id) === key);
      if (existing) {
        return prev.map((i) =>
          (i.key || i.id) === key ? { ...i, qty: i.qty + (item.qty || 1) } : i
        );
      }
      return [...prev, { ...item, qty: item.qty || 1 }];
    });
    if (openDrawer) setOpen(true);
  }, []);

  const updateQty = useCallback((key, qty) => {
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => (i.key || i.id) !== key)
        : prev.map((i) => ((i.key || i.id) === key ? { ...i, qty } : i))
    );
  }, []);

  const removeItem = useCallback((key) => {
    setItems((prev) => prev.filter((i) => (i.key || i.id) !== key));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const total = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQty, removeItem, clear, count, total, open, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};
